import { render } from "./VideoModal.vue?vue&type=template&id=0d76709c&ts=true"
import script from "./VideoModal.vue?vue&type=script&lang=ts"
export * from "./VideoModal.vue?vue&type=script&lang=ts"

import "./VideoModal.vue?vue&type=style&index=0&id=0d76709c&lang=scss"

import exportComponent from "/codebuild/output/src329832614/src/web-ext-giantstep/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__